import { Directive } from '@angular/core';
import { TextInputComponent } from '@thiememeulenhoff/albert';
import { BaseValueAccessorDirective, valueAccessorProvider } from './base';

@Directive({
  selector:
    // eslint-disable-next-line @angular-eslint/directive-selector
    'a-text-input[ngModel],a-text-input[formControl],a-text-input[formControlName], a-feedback-text-input[ngModel],a-feedback-text-input[formControl],a-feedback-text-input[formControlName]',

  providers: [valueAccessorProvider(TextInputValueAccessorDirective)],
})
export class TextInputValueAccessorDirective extends BaseValueAccessorDirective<
  TextInputComponent,
  string
> {}
